<template>
    <v-form
        ref="form"
        v-model="isValid"
        @submit.prevent="save()">
        <v-card>
            <v-card-title>
                <span class="headline">{{ isEdit ? "Edit" : "Add" }} {{ entity.singleTitle }}</span>
            </v-card-title>

            <v-card-text :key="contactKey">
                <form-search-select
                    v-if="siteIdField"
                    v-model="item.siteId"
                    :field="siteIdField"
                    :filter="siteFilter"
                    validate-on-blur
                    @save="save" />
                <component
                    :is="getComponent(field)"
                    v-for="(field, index) in filteredFields"
                    :key="field.value"
                    v-model="item[field.key]"
                    :field="field"
                    :autofocus="index == 0"
                    validate-on-blur
                    @save="save" />
                <div
                    v-for="(email, i) in item.emails"
                    :key="i+'email'"
                    class="d-flex flex-nowrap justify-center mr-0">
                    <app-text-field
                        v-model="item.emails[i]"
                        :label="getLabel('Email', item.emails, i)"
                        :rules="i === 0 && requireEmail ? [v => !!v || 'Email is required'] : undefined"
                        @input="forceEmailValidation" />
                    <app-icon-button
                        v-if="item.emails.length !== 1"
                        color="primary"
                        icon="mdi-close"
                        class="ml-2"
                        @click="removeItem('emails', i)" />
                    <app-icon-button
                        v-if="i === item.emails.length - 1"
                        color="primary"
                        icon="mdi-plus"
                        class="ml-2"
                        @click="addItem('emails', '')" />
                </div>
                <div
                    v-for="(phoneNumber, i) in item.phoneNumbers"
                    :key="i+'phone'"
                    class="d-flex flex-nowrap justify-center mr-0">
                    <app-text-field
                        v-model="item.phoneNumbers[i]"
                        :label="getLabel('Phone Number', item.phoneNumbers, i)" />
                    <app-icon-button
                        v-if="item.phoneNumbers.length !== 1"
                        color="primary"
                        icon="mdi-close"
                        class="ml-2"
                        @click="removeItem('phoneNumbers', i)" />
                    <app-icon-button
                        v-if="i === item.phoneNumbers.length - 1"
                        color="primary"
                        icon="mdi-plus"
                        class="ml-2"
                        @click="addItem('phoneNumbers', '')" />
                </div>
                <div
                    v-for="(address, i) in item.addresses"
                    :key="i+'address'"
                    class="d-flex flex-nowrap justify-center mr-0">
                    <app-text-field
                        v-model="item.addresses[i]"
                        :label="getLabel('Address', item.addresses, i)" />
                    <app-icon-button
                        v-if="item.addresses.length !== 1"
                        color="primary"
                        icon="mdi-close"
                        class="ml-2"
                        @click="removeItem('addresses', i)" />
                    <app-icon-button
                        v-if="i === item.addresses.length - 1"
                        color="primary"
                        icon="mdi-plus"
                        class="ml-2"
                        @click="addItem('addresses', '')" />
                </div>
            </v-card-text>
            <v-divider />
            <v-card-actions class="pa-4">
                <app-button
                    v-if="canDelete"
                    color="error"
                    text
                    @click="deleteItem">
                    Delete
                </app-button>
                <v-spacer />
                <app-button
                    v-if="canCancel"
                    color="secondary"
                    text
                    @click="$emit('cancel')">
                    Cancel
                </app-button>
                <app-button
                    v-if="canSave"
                    type="submit"
                    text
                    :disabled="isSaving || (requireEmail && !hasValidEmail)">
                    Save
                </app-button>
            </v-card-actions>

            <v-progress-linear v-if="isSaving" indeterminate color="blue" />
        </v-card>
    </v-form>
</template>

<script>
import formMixin from "@/features/schemas/mixins/formMixin";
import FormSearchSelect from "@/features/schemas/formFields/FormSearchSelect.vue";

export default {
    components: {
        FormSearchSelect,
    },
    mixins:[ formMixin ],
    types: [
        "contact"
    ],
    props: {
        requireEmail: {
            type: Boolean,
            default: false
        },
        siteFilter: {
            type: Object,
            default: null,
        }
    },
    data() {
        return {
            contactKey: 0,
            emailUpdated: 0
        };
    },
    computed: {
        siteIdField() {
            return this.fields.find(e => e.key === "siteId");
        },
        filteredFields() {
            let manualFields = [
                "siteId",
                "emails",
                "phoneNumbers",
                "addresses"
            ];
            return this.fields.filter(e => !manualFields.includes(e.key));
        },
        hasValidEmail() {
            this.emailUpdated;
            return this.item.emails &&
                this.item.emails.length > 0 &&
                this.item.emails[0] &&
                this.item.emails[0].trim() !== '';
        }
    },
    watch: {
        item: {
            deep: true,
            immediate: true,
            handler() {
                if (!this.item.emails?.length) {
                    this.item.emails = [''];
                }
                if (!this.item.phoneNumbers?.length) {
                    this.item.phoneNumbers = [''];
                }
                if (!this.item.addresses?.length) {
                    this.item.addresses = [''];
                }
            }
        },
        'item.emails': {
            deep: true,
            handler() {
                this.emailUpdated++;
            }
        }
    },
    methods: {
        getField(value) {
            return this.fields.find(e => e.key == value);
        },
        getLabel(base, items, index) {
            return base + (items.length > 1 ? ' ' + (index + 1) : '');
        },
        addItem(key, item) {
            this.item[key].push(item);
            this.contactKey++;
            if (key === 'emails') {
                this.emailUpdated++;
            }
        },
        removeItem(key, index) {
            this.item[key].splice(index, 1);
            this.contactKey++;
            if (key === 'emails') {
                this.emailUpdated++;
            }
        },
        forceEmailValidation() {
            this.emailUpdated++;
        }
    }
}
</script>
